import React, { useMemo } from 'react'
import { Spin, Table } from 'antd'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { Wrapper, TableWrapper } from './styled'
import { Title } from '..'
import { useGetQuery } from '../../../../hooks'
import { getUnitPath } from '../../../../utils'
import { DEFAULT_PAG, STATUS } from '../../constants'
import { SLASH_DATE_FORMAT } from '../../../../utils/date'

const ViewingHistory = ({ t, profile, history, isLoading, loadStudyCourseHistoryAction, getValues }) => {
  const { queryWorkspaceID } = useGetQuery()

  const dataSource = useMemo(() => history?.result.map((item) => ({
    ...item,
    key: item.actualCompleteTime,
    complete: item.complete === STATUS.COMPLETED ? t('course_activity.completed') : t('course_activity.uncompleted'),
    actualCompleteTime: dayjs(item.actualCompleteTime).format(SLASH_DATE_FORMAT)
  })), [history, t])

  const columns = [
    {
      title: t('course_activity.course'),
      dataIndex: 'courseName',
      key: 'courseName',
      width: '350px'
    },
    {
      title: t('course_activity.lesson'),
      dataIndex: 'unitName',
      key: 'unitName',
      render: (text, record) => {
        const { courseUnitType: type, courseId, unitLessonId, unitReportId, unitSurveyId, unitTestId } = record
        const unitId = unitLessonId ?? unitReportId ?? unitSurveyId ?? unitTestId
        const path = getUnitPath({ type, unitId, courseId })
        return <Link to={`${path}${queryWorkspaceID.ONLY}`}>{text}</Link>
      }
    },
    {
      title: t('course_activity.status'),
      dataIndex: 'complete',
      key: 'complete',
      width: '150px'
    },
    {
      title: t('course_activity.viewing_date'),
      dataIndex: 'actualCompleteTime',
      key: 'actualCompleteTime',
      width: '200px'
    }
  ]

  const onChange = (page) => {
    const userId = profile?.isViewHistoryAuthority ? getValues('userId') : profile.userId
    const completeStartTime = getValues('completeStartTime').valueOf()
    const completeEndTime = getValues('completeEndTime').valueOf()
    loadStudyCourseHistoryAction({
      userId,
      completeStartTime,
      completeEndTime,
      limit: DEFAULT_PAG.limit,
      page
    })
  }

  return (
    <Wrapper>
      <Title>{t('course_activity.viewing_history')}</Title>

      <TableWrapper>
        <Spin spinning={isLoading}>
          <Table
            columns={columns}
            dataSource={dataSource}
            pagination={{
              pageSize: DEFAULT_PAG.limit,
              total: history?.total,
              onChange
            }}
          />
        </Spin>
      </TableWrapper>
    </Wrapper>
  )
}

ViewingHistory.propTypes = {
  profile: PropTypes.object,
  t: PropTypes.func.isRequired,
  history: PropTypes.object,
  isLoading: PropTypes.bool,
  loadStudyCourseHistoryAction: PropTypes.func,
  getValues: PropTypes.func
}

export default ViewingHistory
